import React, { useState } from "react";
import { adminLogin } from "../../../services/apiService";

const DashboardPasswordGate = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError("");
    try {
      const result = await adminLogin(password);
      if (result.success) {
        onSuccess();
      } else {
        setError(result.error || "Falsches Passwort. Bitte versuchen Sie es erneut.");
        setPassword("");
      }
    } catch (err) {
      setError("Verbindungsfehler. Bitte versuchen Sie es erneut.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f6f8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      fontFamily: 'var(--font-ui)',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        background: 'white',
        borderRadius: '28px',
        padding: '40px 36px',
        border: '1px solid #dde1e7',
        boxShadow: '0 4px 6px rgba(62,73,84,0.04), 0 20px 40px rgba(62,73,84,0.08)',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Top accent bar */}
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: '3px',
          background: '#3E4954',
        }} />

        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '32px' }}>
          <img src="https://zba.academy/webinar/images/zbalogo2.png" alt="ZBA Academy" style={{ height: '40px', width: 'auto' }} />
        </div>

        <div style={{ marginBottom: '8px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '4px 12px', background: 'rgba(62, 73, 84, 0.08)', borderRadius: '100px', marginBottom: '16px' }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3E4954" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <span style={{ fontSize: '11px', fontWeight: 700, color: '#3E4954', letterSpacing: '0.04em' }}>GESCHÜTZTER BEREICH</span>
          </div>
        </div>

        <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '26px', fontWeight: 700, color: '#1e2b38', marginBottom: '8px', letterSpacing: '-0.02em', lineHeight: 1.2 }}>
          Buchungs-Dashboard
        </h1>
        <p style={{ fontSize: '14px', color: '#6b7a8d', marginBottom: '28px', lineHeight: 1.6 }}>
          Bitte geben Sie das Passwort ein, um auf das Dashboard zuzugreifen.
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#1e2b38', marginBottom: '6px' }}>
              Passwort
            </label>
            <input
              type="password"
              value={password}
              onChange={e => { setPassword(e?.target?.value); setError(""); }}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              placeholder="Dashboard-Passwort eingeben"
              autoFocus
              style={{
                width: '100%',
                height: '48px',
                padding: '0 14px',
                border: error ? '1.5px solid #dc2626' : focused ? '1.5px solid #3E4954' : '1.5px solid #dde1e7',
                borderRadius: '12px',
                fontSize: '14px',
                fontFamily: 'var(--font-ui)',
                color: '#1e2b38',
                background: 'white',
                outline: 'none',
                transition: 'border-color 200ms ease, box-shadow 200ms ease',
                boxShadow: error ? '0 0 0 3px rgba(220, 38, 38, 0.08)' : focused ? '0 0 0 3px rgba(62, 73, 84, 0.1)' : 'none',
              }}
            />
            {error && (
              <p style={{ fontSize: '12px', color: '#dc2626', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {error}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={!password || loading}
            className="btn-primary"
            style={{ width: '100%' }}
          >
            {loading ? (
              <>
                <svg className="animate-spin" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.25"/>
                  <path fill="currentColor" opacity="0.75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                </svg>
                Wird geprüft…
              </>
            ) : (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                Anmelden
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DashboardPasswordGate;
